// extracted by mini-css-extract-plugin
export var brand = "_72-9";
export var compact = "_72-6";
export var extraSmall = "_72-7";
export var icon = "_72-0";
export var large = "_72-4";
export var light = "_72-1";
export var medium = "_72-5";
export var outline = "_72-b";
export var primaryDark = "_72-a";
export var primaryLight = "_72-8";
export var primaryModern = "_72-c";
export var success = "_72-2";
export var successSolid = "_72-3";